export class Spend {
    public spendTime: number;
    public spendAmount: number;
    public spendQuantity?: number;
}
